import { connect } from 'react-redux'
import CollaborativeIndexationCreation from './CollaborativeIndexationCreation.jsx'
import {
    getCollaborativeIndexationCampaignIndexationType,
    isCollaborativeIndexationCreationCloseConfirmationNeeded,
} from '../../../../redux/collaborativeIndexations/selectors'
import {
    cancelCollaborativeIndexationCreationClose,
    closeCollaborativeIndexationCreation,
    confirmCloseCollaborativeIndexationCreation,
} from '../../../../redux/collaborativeIndexations/actions'
import { isUserCollaborativeIndexerStatusActive } from '../../../../redux/app/selectors'

const mapDispatchToProps = (dispatch, getState) => ({
    close: () => dispatch(closeCollaborativeIndexationCreation()),
    confirmClose: () => dispatch(confirmCloseCollaborativeIndexationCreation()),
    cancelClose: () => dispatch(cancelCollaborativeIndexationCreationClose()),
})

const mapStateToProps = state => ({
    indexationType: getCollaborativeIndexationCampaignIndexationType(state),
    isUserCollaborativeIndexerStatusActive: isUserCollaborativeIndexerStatusActive(state),
    isCloseConfirmationNeeded: isCollaborativeIndexationCreationCloseConfirmationNeeded(state),
})

export const CollaborativeIndexationCreationContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(CollaborativeIndexationCreation)
